
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WelcomePage from "../pages/welcome/WelcomePage";
import OnboardingPage from "../pages/onboarding/OnboardingPage";
import LoginPage from "../pages/auth/LoginPage";
import SignUpPage from "../pages/auth/SignUpPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import AuthCallbackPage from "../pages/auth/Callback";
import FamilySetupPage from "../pages/setup/FamilySetupPage";
import AddMemberPage from "../pages/setup/AddMemberPage";
import MemberDashboard from "../pages/member/MemberDashboard";
import AdminDashboard from "../pages/admin/AdminDashboard";
import RequireAdmin from "./RequireAdmin";
import AdminLoginPage from "../pages/admin/AdminLoginPage";
import RemediesLibraryPage from "../pages/remedies/RemediesLibraryPage";
import TermsAndPrivacyPage from "../pages/legal/TermsAndPrivacyPage";
import ProfilePage from "../pages/profile/ProfilePage";
import SettingsPage from "../pages/settings/SettingsPage";
import ChangePasswordPage from "../pages/settings/ChangePasswordPage";
import FeedbackPage from "../pages/settings/FeedbackPage";
import RateUsPage from "../pages/settings/RateUsPage";
import HelpCenterPage from "../pages/settings/HelpCenterPage";
import TermsConsentGate from "../components/guards/TermsConsentGate";
import { PaymentPage } from "../pages/payment/PaymentPage";
import PurchaseSOSPage from "../pages/purchase/PurchaseSOSPage";
import InstagramWelcomePage from "../pages/instagram/InstagramWelcomePage";
import InstagramOnboardingPage from "../pages/instagram/InstagramOnboardingPage";
import InstagramSignupPage from "../pages/instagram/InstagramSignupPage";
import InstagramEmailSentPage from "../pages/instagram/InstagramEmailSentPage";
import InstagramEmailConfirmedPage from "../pages/instagram/InstagramEmailConfirmedPage";
import EmailSentPage from "../pages/auth/EmailSentPage";
import EmailConfirmedPage from "../pages/auth/EmailConfirmedPage";
import HelpInstallPage from "../pages/help/HelpInstallPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <WelcomePage />,
  },
  {
    path: "/onboarding",
    element: <OnboardingPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <SignUpPage />,
  },
  {
    path: "/signup/email-sent",
    element: <EmailSentPage />,
  },
  {
    path: "/signup/confirmed",
    element: <EmailConfirmedPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallbackPage />,
  },
  {
    path: "/setup-family",
    element: (
      <TermsConsentGate>
        <FamilySetupPage />
      </TermsConsentGate>
    ),
  },
  {
    path: "/add-member",
    element: <AddMemberPage />,
  },
  {
    path: "/dashboard",
    element: <Home />,
  },
  {
    path: "/member/:memberId",
    element: <MemberDashboard />,
  },
  {
    path: "/remedies",
    element: <RemediesLibraryPage />,
  },
  {
    path: "/admin-login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: (
      <RequireAdmin>
        <AdminDashboard />
      </RequireAdmin>
    ),
  },
  {
    path: "/terms-and-privacy",
    element: <TermsAndPrivacyPage />,
  },
  {
    path: "/instagram",
    element: <InstagramWelcomePage />,
  },
  {
    path: "/instagram/onboarding",
    element: <InstagramOnboardingPage />,
  },
  {
    path: "/instagram/signup",
    element: <InstagramSignupPage />,
  },
  {
    path: "/instagram/email-sent",
    element: <InstagramEmailSentPage />,
  },
  {
    path: "/instagram/confirmed",
    element: <InstagramEmailConfirmedPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  {
    path: "/settings/change-password",
    element: <ChangePasswordPage />,
  },
  {
    path: "/feedback",
    element: <FeedbackPage />,
  },
  {
    path: "/rate-us",
    element: <RateUsPage />,
  },
  {
    path: "/help-center",
    element: <HelpCenterPage />,
  },
  {
    path: "/help/install",
    element: <HelpInstallPage />,
  },
  {
    path: "/payment",
    element: (
      <TermsConsentGate>
        <PaymentPage />
      </TermsConsentGate>
    ),
  },
  {
    path: "/purchase-sos",
    element: (
      <TermsConsentGate>
        <PurchaseSOSPage />
      </TermsConsentGate>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
